import misc from '@/Services/misc';
import { getError } from '@/utils/helpers';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useBusinessStore } from './business';
import businessService from '@/Services/business';

export const useMiscStore = defineStore('misc', () => {
  const sectors = ref([]),
   currentSector = ref(null),
   currentCategory = ref(null),
   loading = ref(false),
      loadingSector = ref(false),
   error = ref(null),
   route = useRoute(),
   businessStore = useBusinessStore(),
   sectorFilters = ref([]),
   categoryFilters = ref([]),
   regionFilters = ref([]),
   cityFilters = ref([]),
   sortingFilters = ref([
    {
      label: 'Name',
      value: 'name',
    },
    {
      label: 'Rating',
      value: 'rating',
    },
    {
      label: 'Most viewed',
      value: 'votes',
    },
   ]), 

   setSectors = async (value) => {
      await businessStore.setBusinesses([]);
    sectors.value = value;
  },

  setSectorFilters = async (value) => {
    sectorFilters.value = value.filter((sector) => sector.id !== 0 || sector.id !== -1);
  },

  setCategoryFilters = async (value) => {
    categoryFilters.value = value;
  },

  setRegionFilters = async (value) => {
    regionFilters.value = value;
  },

  setCityFilters = async (value) => {
    cityFilters.value = value;
  },

  setSortingFilters = async (value) => {
    sortingFilters.value = value;
  },

   setCurrentSector = async (value) => {
     // console.log(value, 'setCurrentSector');
     if (value === undefined || value === null) {
       currentSector.value = {
         id: 0,
         name: 'Home',
         slug: 'home',
         current: true,
         icon: 'heroicon-o-home',
         type: 'Home',
       };
       value = {
         id: 0,
         name: 'Home',
         slug: 'home',
         current: true,
         icon: 'heroicon-o-home',
         type: 'Home',
       };
     } else {
       currentSector.value = value;
     }
     sectors.value.map((sector) => {
      sector.current = sector?.slug === value?.slug;
     })
  },
  updateCurrentSector = async (value) => {
    let sectorsIndex = sectors.value.findIndex(sector => sector.slug === value);
    if (value === undefined || value === null) {
      currentSector.value = {
        id: 0,
        name: 'Home',
        slug: 'home',
        current: true,
        icon: 'heroicon-o-home',
        type: 'Home',
      };
      return;
    }
    currentSector.value = sectors.value[sectorsIndex];
    // console.log(currentSector, 'After setting currentSector');
    
  },

   setCurrentCategory = async (value) => {
    currentCategory.value = value;
  },

   fetchSectors = async () => {
    try {
      loadingSector.value = true;
      const { data } = await misc.sectors(),
       navigations = data.map((sector) => misc.constructSector(sector));
       await setSectorFilters(navigations);
      navigations.unshift({
        id: 0,
        name: 'Home',
        slug: 'home',
        current: true,
        icon: 'heroicon-o-home',
        type: 'Home',
      });
      navigations.push({
        id: -1,
        name: 'About Us',
        slug: 'about',
        current: false,
        icon: 'heroicon-o-mail',
        type: 'About',
      })
      await setSectors(navigations);
      setCurrentSector(navigations.find((sector) => sector.slug === route.params.sector));
      error.value = null;
    } catch (err) {
      // console.log(err);

      error.value = getError(error);
    } finally {
      loadingSector.value = false;
    }
  },

   fetchCategory = async (category) => {
    if (currentCategory.value && currentCategory.value?.slug === category) {
      return;
    }
    try {
      loading.value = true;
      const { data } = await misc.category(category);
      await setCurrentCategory(misc.constructCategory(data));
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  fetchCategories = async () => {
    loading.value = true;
    try {
      const { data } = await misc.categories();
      await setCategoryFilters(data.map((category) => misc.constructCategory(category)));
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  fetchCategoriesBySector = async (sector) => {
    loading.value = true;
    try {
      const { data } = await misc.categoriesBySector(sector);
      await setCategoryFilters(data.map((category) => misc.constructCategory(category)));
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  fetchRegions = async () => {
    loading.value = true;
    try {
      const { data } = await misc.regions();
      await setRegionFilters(data.map((region) => misc.constructRegion(region)));
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  fetchCities = async () => {
    loading.value = true;
    try {
      const { data } = await misc.cities();
      
      await setCityFilters(data.map((city) => misc.constructCity(city)));
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  fetchCitiesByRegions = async (region) => {
    loading.value = true;
    try {
      const { data } = await misc.citiesByRegion(region);
      await setCityFilters(data.map((city) => misc.constructCity(city)));
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  search = async (query = null, sector = null, category = null) => {
    loading.value = true;
    try {
      const { data } = await misc.search(
          `q=${query.value}&sector=${sector}&category=${category}`
          ),
      businesses = data.data.map((business) => 
        businessService.constructBusiness(business)
      );      
      await useBusinessStore().setBusinesses(businesses);
      error.value = null;
    } catch (err) {
      // console.log(err);
      
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },
  
  toggleFollowing = async (id) => {
    try {
      loading.value = true;
      await misc.toggleFollowing({user_id: id});
      await businessStore.updateBusinessCreatorFollowStatus();
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  }

  return {
    sectors,
    currentSector,
    currentCategory,
    sectorFilters,
    categoryFilters,
    regionFilters,
    cityFilters,
    sortingFilters,
    loading,
    loadingSector,
    error,
    setSectors,
    setCurrentSector,
    setCurrentCategory,
    setSectorFilters,
    setCategoryFilters,
    setRegionFilters,
    setCityFilters,
    setSortingFilters,
    fetchSectors,
    fetchCategory,
    fetchCategories,
    fetchCategoriesBySector,
    fetchRegions,
    fetchCities,
    fetchCitiesByRegions,
    toggleFollowing,
    updateCurrentSector,
    search,
  };
});
